import { useIntl } from "react-intl";

export function useWorkspaceTodoArchiveDescription() {
  const intl = useIntl();
  return intl.formatMessage({
    defaultMessage: `Archiving moves this to-do to the archives and removes it from all receiver units.`,
    description: "WorkspaceTodoDetail Archive Description",
  });
}
